import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { C } from '../commons/index';
import { Cookies } from '../commons';
import { HeaderDTO } from '../dto/header.dto';

export interface EvidenciaItemRequest {
    idRef: number;
    codigoViaje: string;
    nroTarea: string;
}

export interface DescargaEvidenciaMasivaRequest {
    tipoReporte: string;
    items: EvidenciaItemRequest[];
}

@Injectable()
export class DescargaMasivaEvidenciasService {

  constructor(private http: HttpClient) { }

  descargarZip(request: DescargaEvidenciaMasivaRequest): Observable<Blob> {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let language = Cookies.getCookie("LANGUAGE");
    const app = C.APP;

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/zip');
    
    if (currentUser != null) {
      headers = headers.append('X-AUTH-TOKEN', 'Bearer ' + currentUser.token);
    }
    if (language != null) {
      headers = headers.append('Language', language);
    }

    const headerDTO = new HeaderDTO();
    headerDTO.aplicacion = app;
    headerDTO.usuarioId = currentUser ? currentUser.usuarioId : null;
    
    headers = headers.append('HeadersDTO', JSON.stringify(headerDTO));

    return this.http.post(`${C.BASE}/reportes/evidencias/descarga-masiva`, request, {
      headers: headers,
      responseType: 'blob'
    });
  }
}
